import axiosInstance from '../http';
import { API } from '@/shared/constants/api';
import { ROLES } from '@/shared/constants/roles';
import ServiceBuilder from '@/shared/lib/utils/service';
export var ReminderFailReasons;
(function (ReminderFailReasons) {
    ReminderFailReasons["DAY_LIMIT_EXCEEDED"] = "DAY_LIMIT_EXCEEDED";
})(ReminderFailReasons || (ReminderFailReasons = {}));
const loginByRole = async ({ role, ...params }) => ServiceBuilder.serviceRequest(async () => {
    const response = await axiosInstance.post(role === ROLES.user ? API.login : API.loginPerformers, params);
    return response;
});
const sendReminder = async ({ email }) => ServiceBuilder.serviceRequest(async () => {
    const response = await axiosInstance.post(API.reminder, { email });
    return response;
});
const validatePasswordResetCode = async ({ role, ...params }) => ServiceBuilder.serviceRequest(async () => {
    const response = await axiosInstance.post(role === ROLES.user ? API.validateCode : API.performerValidateCode, params);
    return response;
});
const logout = (userId) => ServiceBuilder.serviceRequest(() => axiosInstance.post(`${API.logout}/${userId}`));
const AuthService = {
    loginByRole,
    validatePasswordResetCode,
    sendReminder,
    logout,
};
export default AuthService;
